import { Component } from '@angular/core';

@Component({
  selector: 'sfa-home',
  standalone: true,
  template: `
    <div>
      <div class="alert alert-warning mt-3" role="alert">
        <h4 class="alert-heading">VPN Connection Required</h4>
        <p>
          To use the Student Forms Admin application, please connect to AU's VPN first.
        </p>
        <hr />
        <p class="mb-0">
          Need help setting up the VPN or logging in? Contact the IT Help Desk.
        </p>
      </div>

      <h2 class="welcome" data-cy="welcome-message">Welcome to Student Forms Admin!</h2>
      <p>
        <strong>Important Notice: Internal Use Only</strong>
      </p>
      <p>
        This software application is exclusively intended for use by employees and
        authorized personnel of Athabasca University. Access to and use of this
        application is restricted to individuals with valid credentials and
        authorization. Any unauthorized access or use of this software is strictly
        prohibited and may result in disciplinary or legal action.
      </p>
      <p>
        By using this application, you agree to abide by the organization's policies
        and guidelines for information technology usage. All data and information
        processed or stored within this application must comply with security and
        data privacy policies.
      </p>
      <p>
        Thank you for your cooperation in maintaining the security and
        confidentiality of our organization's resources.
      </p>
    </div>
  `,
  styles: [`
    .welcome {
      margin-top: 1.5rem;
    }
  `]
})
export class HomeComponent {}
